import { AssetDropDown } from "../UiComponents/AssetDropDown";
import { SBAComboBox } from "../UiComponents/SBADropDown";
import { getAssestListddlAction } from "../actions/assetsddlAction";
import { useDispatch, useSelector } from 'react-redux';
import React, { useState, useEffect, useRef, useMemo } from 'react'
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { getAsset } from "../actions/assetAction";
import { useParams,useNavigate } from 'react-router-dom'
import moment from "moment";
import { sbaAxios } from '../utils/sbaAxios';
import { getUserPageAccess } from "../../config/apiConfig";
import { getAssetPricingAction } from "../actions/pricingAction";
import { AgGridReact } from "ag-grid-react";
import { SBDatePicker } from "../UiComponents/SBDatePicker";
import { UrlPath } from "../../config/routeConfig";
import { LoadingScreen } from "../UiComponents/LoadingComponent";
import { useLocation } from 'react-router-dom';
import download from '../../Images/download.svg';
import { exportToExcelUsingRef } from "../utils/excelExporter";
export const Pricing = () => {
    const Gstate =
        useSelector((state) => {
            return state;
        }) || {};
    const history = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();
    const location = useLocation();
    const valuationRef=useRef();
    const currentDate = new Date();
    const firstDayOfCurrentMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const lastDayOfPreviousMonth = new Date(firstDayOfCurrentMonth.getTime() - 1);
    const [SelectedDate, setSelectedDate] = useState(
        location.state && location.state.PricingDate !== null
            ? location.state.PricingDate
            : lastDayOfPreviousMonth
    );
    const [selectedAssetid, setSelectedAssetid] = useState(params.AssetId);
    const [hideZeroPosition, SetHideZeroPosition] = useState(location.state && location.state.HideZeroBalance !== null
        ? location.state.HideZeroBalance
        : true);
    const [hidePortfolios, SetHidePortfolios] = useState(location.state && location.state.HideActivePortfolios !== null
        ? location.state.HideActivePortfolios
        : false);
    const [pricingData, setPricingData] = useState();
    const [valuationEditAccess, setValuationEditAccess] = useState();
    const [valuationDateChange,setValuationDateChange]=useState(0);
    const AssetListDDL = Gstate.assetDDL.assetList || [];

    const firstDateOfMonth = new Date(SelectedDate.getFullYear(), SelectedDate.getMonth(), 1);
    const lastDateOfMonth = new Date(SelectedDate.getFullYear(), SelectedDate.getMonth() + 1, 0);
    const lastDateOfPreviousMonth = new Date(firstDateOfMonth.getFullYear(), firstDateOfMonth.getMonth(), 0);

    const currentAsset = Gstate.asset.asset || {};
    const isPricinggridLoading = Gstate.AssetpricingList.isPricingLoading;
    let LocalDate = SelectedDate;
    const formattedSelectDate = moment(LocalDate).format("MM-DD-yyyy");
    const isEditable = Gstate.authorizationData.isEditable;
    
    useEffect(() => {
        getValuationEditAccess();
        dispatch(getAssestListddlAction());
        dispatch(getAsset(params.AssetId));
        dispatch(getAssetPricingAction(params.AssetId, formattedSelectDate));
    }, []);
    useEffect(()=>{
      if(valuationDateChange>0)
      {
        gobtnClick();
      }
    },[valuationDateChange])

    const PriceDatechange = (e) => {
        setSelectedDate(e.toDate());
    };
    const priceDateOnBlur=(e)=>{
      const date=moment(e).format("MM-DD-yyyy");
      if(date!='Invalid date')
      getValuationDataByAssetAndDate(selectedAssetid,date);
    };
    const priceDateOnClose=(e)=>{
      // const date=moment(e).format("MM-DD-yyyy");
      // if(date!='Invalid date')
      // getValuationDataByAssetAndDate(selectedAssetid,date);    
      setValuationDateChange(val=>val+1);

    };
    const AssetDDChanged = (e) => {
        if (e.value) {
            history(`${UrlPath.Valuation}${e.value.AssetId}`);
            dispatch(getAsset(e.value.AssetId));
            setSelectedAssetid(e.value.AssetId);
            getValuationDataByAssetAndDate(e.value.AssetId,formattedSelectDate);

        }
    };
    const gobtnClick = () => {
        dispatch(getAssetPricingAction(selectedAssetid, formattedSelectDate));
        hideZeroResult(hideZeroPosition);
    };

    const getValuationDataByAssetAndDate= (assetId,date) => {
        dispatch(getAssetPricingAction(assetId, date));
        hideZeroResult(hideZeroPosition);
    };
    const EditButtonclick = () => {
        const selectedAsset = AssetListDDL.find(item => item.AssetId == params.AssetId);
        if (selectedAsset.IsMarketable)
            history(`${UrlPath.MarketablePostPricing}${params.AssetId}`, { state: { PricingDate: SelectedDate, HideZeroBalance: hideZeroPosition, HideActivePortfolios: hidePortfolios } });
        else
            history(`${UrlPath.ValuationPostPricing}${params.AssetId}`, { state: { PricingDate: SelectedDate, HideZeroBalance: hideZeroPosition, HideActivePortfolios: hidePortfolios } });
    };

    const getValuationEditAccess = async () => {
        try {
            const valuationEditAccessPromise = sbaAxios({ url: `${getUserPageAccess}?keyName=ValuationEditAccess` });
            const [
                valuationEditAccessResponse,

            ] = await Promise.all([
                valuationEditAccessPromise,

            ]);
            setValuationEditAccess(valuationEditAccessResponse);

        } catch (error) {
            console.error("An error occurred:", error);

        }
    };



    useEffect(() => {
        hideZeroResult(hideZeroPosition);
    }, [Gstate])



    const hideZeroResult = (IsHide) => {
      if (IsHide === true) {
        const parent = rowData.filter(
          (item) => !item.isChild && (item.BMV !== 0 || item.PriorMonthEMV !== 0 || item.EMV !== 0)
        );
        const child = rowData.filter(
          (item) => item.isChild && (item.BMV !== 0 || item.PriorMonthEMV !== 0 || item.EMV !== 0)
        );     
        let filterchild=child.map((item)=>
{return{
          ...item,
          ValuationDate:dateValueFormatter(item.ValuationDate),
PostedOn:dateValueFormatter(item.PostedOn)
        }
      })
        const updatedParent = parent.map((parentItem) => {
          const childrenOfParent = child.filter(
            (childItem) => childItem.PortfolioName === parentItem.PortfolioName
          );
          const allChildrenChecked = childrenOfParent.every((childItem) => childItem.IsActual);
          return {
            ...parentItem,
            ValuationDate:dateValueFormatter(parentItem.ValuationDate),
            IsActual: allChildrenChecked ? true : parentItem.IsActual,
          };
        });
      
        setPricingData([...updatedParent, ...filterchild]);
      } else {
        setPricingData( rowData.map((item)=>({...item,ValuationDate:dateValueFormatter(item.ValuationDate),PostedOn:dateValueFormatter(item.PostedOn),
          })));
      }
    }
    const dateValueFormatter = (params) => {
        return params !== null
            ? moment(params).format("MM/DD/YYYY")
            : "";
    };

    const currencyValueFormatter = (params) => {
        const formattedValue = params?.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      
        return formattedValue ? `$ ${formattedValue}` : "";
      };
      
    

    const createRow = (entity, parentIndex, childIndex) => {
        const {
        PortfolioName,
        PostedBy,
        PostedOn,
        PriorMonthEMV,
        BMV,
        EMV,
        Flows,
        Return,
        ReturnValue,
        NAV,
        Shares,
        IsActual,
        ShareClassId,
        ShareClassName,
        ValuationDate,
        AssetLotName,
            PricingLotList,
      } = entity || {};
   
      const isChild = typeof childIndex === 'number';
    
      const CurAllocation = isChild
        ? PricingLotList?.find((allocation) => allocation?.Position)?.Position || null
        : null;
    
      const PerAllocation = isChild ? 100 : null;
      const parentPortfolioName = isChild ? PortfolioName : null;
      const newReturn = isChild ? ReturnValue : Return;
    
        return {
        PortfolioName,
        PostedBy,
        PostedOn,
        PriorMonthEMV: PriorMonthEMV === null ? 0 : PriorMonthEMV,
        BMV: BMV === null ? 0 : BMV,
        EMV: EMV === null ? 0 : EMV,
        Flows,
        newReturn,
        NAV,
        Shares,
        IsActual,
        ShareClassId,
        ShareClassName,
        ValuationDate,
        AssetLotName,
        CurAllocation,
        PerAllocation,
        parentPortfolioName,
        isChild,
            childIndex,
      };
    };
    
    const pricinglist = Gstate.AssetpricingList.AssetpricingList || [];
    
    const rowData = pricinglist?.flatMap((allocation, parentIndex) => {
      const parentRow = createRow(allocation, parentIndex);
    
      const childRows = Array.isArray(allocation?.PricingLotList)
        ? allocation.PricingLotList.map((childEntity, childIndex) =>
            createRow(childEntity, parentIndex, childIndex)
          )
        : [];
    
      return [parentRow, ...childRows];
    });
    
    const getDateFormatted = (params) => {
      const isoDate = params.value;
      try {
        if(isoDate)
        {
          const formattedDate = moment(isoDate).format("MM/DD/YYYY");
          return formattedDate;
        }
        else 
        {
          return '';
        }
      } catch (error) {
       console.log('Error Occured while Date COnversion');
      }
    };
    const FormatCurrencyGrid = (params) => {
      var num = params.value;
      if (num !== undefined && num != null) {
        if (num === 0) {
          return ''
        } else { 
          const isNegative = num < 0;
          const formattedValue = isNegative
            ? `($${Math.abs(num).toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })})`
            : `$${num.toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}`;
          const style = isNegative ? { color: 'red' } : null;
          return <span style={style}>{formattedValue}</span>;
        }
      } else {
        return <span></span>; 
      }
    };
    const FormatpercentCurrencyGrid = (params) => {
  
      var num = params.value;
    
      if (num !== undefined && num != null) {
        if (num === 0) {
          num = 0;
        }
    
         
          const isNegative = num < 0;
    
         
          const formattedValue = isNegative
            ? `${(num).toLocaleString('en-US', {
                minimumFractionDigits: 4,
                maximumFractionDigits: 4,
              })} %`
            : `${num.toLocaleString('en-US', {
                minimumFractionDigits: 4,
                maximumFractionDigits: 4,
              })} %`;
    
         
          const style = isNegative ? { color: 'red' } : null;
    
          return <span style={style}>{formattedValue}</span>;
      
      } else {
        return <span></span>; // Wrap num in a span
      }
    };
    const FormatSharesValue = (params) => {

      var num = params.value;
      if (num !== undefined && num != null) {
        if (num === 0) {
          return '';
        } else {
          const isNegative = num < 0;
          const formattedValue = isNegative
            ? `(${Math.abs(num).toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })})`
            : `${num.toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}`;
    
          const style = isNegative ? { color: 'red' } : null;
    
          return <span style={style}>{formattedValue}</span>;
        }
      } 
      else {
        return <span></span>; 
      }
    };
    const gridValueFormatter = (params) => {
      return <input type='checkbox' checked={params.value} />;
    };
    const columnDefs = [
      {
      headerName: 'Portfolio Name',
      field: 'PortfolioName',
      hide: true,
      },    
      { headerName: 'ShareClass Name', field: 'ShareClassName',editable:false },
      { headerName: 'Lot Name', field: 'AssetLotName',editable:false },
      { headerName: `EMV for ${moment(lastDateOfPreviousMonth).format("MM/DD/yyyy")}`,cellRenderer: FormatCurrencyGrid,cellClass: 'numberFormat' , field: 'PriorMonthEMV',cellStyle: { textAlign: "right" },editable:false  },
      { headerName: `BMV for ${moment(firstDateOfMonth).format("MM/DD/yyyy")}`, field: 'BMV',cellRenderer: FormatCurrencyGrid,cellClass: 'numberFormat' ,cellStyle: { textAlign: "right" },editable:false },
      { headerName: `Flows`, field: 'Flows', cellRenderer: FormatCurrencyGrid,cellClass: 'numberFormat' ,cellStyle: { textAlign: "right" },editable:false },
      { headerName: 'NAV', field: 'NAV',cellRenderer: FormatCurrencyGrid,cellStyle: { textAlign: "right" },editable:false  },
      { headerName: 'Shares', field: 'Shares',cellRenderer: FormatSharesValue,cellStyle: { textAlign: "right" },editable:false  },
      { headerName: 'Return Value', field: 'newReturn', cellRenderer: FormatpercentCurrencyGrid,cellClass: 'currencyFormat' ,cellStyle: { textAlign: "right" },editable:false },
      { headerName: `Current Position ${moment(lastDateOfMonth).format("MM/DD/yyyy")}`,cellRenderer: FormatCurrencyGrid,cellClass: 'numberFormat' , field: 'EMV',cellStyle: { textAlign: "right" },editable:false  },
      { headerName: 'Valuation Date', field: 'ValuationDate',valueFormatter:getDateFormatted,editable:false  },
      { headerName: 'Posted On', field: 'PostedOn',valueFormatter:getDateFormatted,editable:false  },
      { headerName: 'Posted By', field: 'PostedBy',editable:false  },
      {
        field: 'IsActual',
        headerName: "Actual",
          cellRenderer: gridValueFormatter,
          editable:false
    },
    ];
    const excelStyles = useMemo(() => { 
      return [
            {
                id: 'numberFormat',
                numberFormat: {
                    format: '$#,##0.00',
                },
            },
            {
                id: 'currencyFormat',
                numberFormat: { format: '0.0000%',
                },
            },
        ];
    }, []);
    
    const gridOptions = {
      columnDefs: columnDefs,
      rowData: rowData,
      animateRows: true,
      treeData: true,
      groupDefaultExpanded: -1,
        getDataPath: (data) => {
        if (data.isChild) {
          return [data.parentPortfolioName, `C-${data.childIndex} ${data.PortfolioName}`];
        }
        return [data.PortfolioName];
      },
      
    };          
  

    const autoGroupColumnDef = useMemo(() => {
      return {
          headerName: 'Portfolio Name',
          field: 'PortfolioName',
          minWidth: 450,
          cellRendererParams: {
              suppressCount: true,
          },
          pinned: "left",
          editable: false,
          headerClass:"ag-grid-BR"
      }
    }, []);    

    const defaultDef = {
    flex: 1,
    minWidth: 150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    editable: true,
    cellDataType: false,
    resizable:true
    };
    
                
    return (
      <div id="Pricing">
        <div id="content" className="mainContentData taxDetails">
          <div className="container-fluid TaxPage mb-4">
            <div className="row">
              <div className="col-md-3">
                <label htmlFor="select fund" className="mb-1">
                  Asset
                </label>
                <SBAComboBox
                  value={currentAsset}
                  onChange={AssetDDChanged}
                  data={AssetListDDL}
                  textField="AssetName"
                  valueField="AssetId"
                  />
              </div>
              <div className="col-md-2">
                <label className="mb-1">Price Date</label>
                <div className="d-block">
                  <SBDatePicker
                    value={moment(SelectedDate)}
                    onChange={PriceDatechange}
                    format="MM/DD/YYYY"
                    onBlur={priceDateOnBlur}
                    onClose={priceDateOnClose}
                  />
                </div>
               
              </div>
              <div className="col-md-3 d-flex row-items">
              <div className="me-2">
                  <input
                    className="me-1"
                    type="checkbox"
                    defaultChecked={hideZeroPosition}
                    onChange={(e) => {
                      SetHideZeroPosition((value) => !value);
                      gobtnClick();
                    }}
                  />
                  <span>Hide Zero Balances</span>
                </div>
                <div className="me-2">
                  <input
                    className="me-1"
                    type="checkbox"
                    defaultChecked={hidePortfolios}
                    onChange={(e) => {
                      SetHidePortfolios((value) => !value);
                      gobtnClick();
                    }}
                  />
                  <span>Hide Inactive Portfolios</span>
                </div>
              </div>
              <div className="col-md-4 ms-auto row-items d-flex justify-content-end">
                {!valuationEditAccess ? (
                  <> </>
                ) : (
                  <button
                    type="submit"
                    className="p-sm-btn mx-1"
                    disabled={!isEditable}
                    onClick={EditButtonclick}
                  >
                    Edit
                  </button>
                )}
                <button
                  type="submit"
                  className="p-sm-btn mx-1"
                  onClick={gobtnClick}
                >
                  Enter
                </button>
                <button type="button" className="p-sm-btn mx-1" onClick={() => { exportToExcelUsingRef(valuationRef, 'Valuations') }}><img src={download} alt="Excel" />Export</button>
              </div>
            </div>
          </div>

          <div className="col-lg-12">
            {isPricinggridLoading ? (
              <LoadingScreen />
            ) : (
              <>
                <div
                  className="ag-theme-alpine"
                  style={{ height: "70vh", width: "100%" }}
                >
                  <AgGridReact
                    rowData={pricingData}
                    ref={valuationRef}
                    excelStyles={excelStyles}
                    columnDefs={columnDefs}
                    gridOptions={gridOptions}
                    autoGroupColumnDef={autoGroupColumnDef}
                    defaultColDef={defaultDef}
                    getRowClass={(e) => {
                      if (e.data.parentPortfolioName === null) {
                        return "sbGridParentRow";
                      }
                    }}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
}